<ui-toolbar-top [title]="'Order'" [backVisible]="true"></ui-toolbar-top>

<ui-user-order [transactionId]="transactionId"></ui-user-order>